//const mainDomain = "http://localhost:5001/"
const mainDomain = "https://users.bestembroidery.org/";

const Constants = {
  imgDomain: "https://users.bestembroidery.org",
  // imgDomain: "http://localhost:5001",

  getUrls: {
    getAllCategory: mainDomain + "category",
    getAllCollections: mainDomain + "collection",
    getAllStyles: mainDomain + "styles/get-all",
    getSingleStyle: mainDomain + "styles",
    getAllProducts: mainDomain + "products/product-list",
    getAllCustomizedProducts: mainDomain + "products/customized-product-list",
    getProductsCount: mainDomain + "products/get-product-count",
    toggleProduct: mainDomain + "products/toggle-favorite",
    getAllDesigns: mainDomain + "design",
    getProduct: mainDomain + "products",
    getAllFabric: mainDomain + "fabric/Allfabric",
    getSingleFabric: mainDomain + "fabric",
    getAllThread: mainDomain + "thread",
    getCart: mainDomain + "cart",
    getAllCustomizedImage: mainDomain + "customized_image",
    getAdminCustomizedImage: mainDomain + "customized_image/admin",
    getCustomizedImage: mainDomain + "customized_image/get-data",
    getUserData: mainDomain + "user/details",
    getUserAddress: mainDomain + "useraddress", //:id
    getMyOrders: mainDomain + "order/get-my-orders",
    getOrder: mainDomain + "order",
    getAddOns: mainDomain + "addOn",
    upsConfig: mainDomain + "ups/config",
    upsTrack: mainDomain + "ups/track",
    upsOrderTrack: mainDomain + "ups/order",
    
  },
  postUrls: {
    login: mainDomain + "user/login",
    addProducts: mainDomain + "products/create",
    signup: mainDomain + "user/create",
    changePassword: mainDomain + "user/changePass",
    AddToCart: mainDomain + "cart/create",
    updateQuantity: mainDomain + "cart/updateQty/",
    placeOrder: mainDomain + "order/create",
    getMultipleProduct: mainDomain + "products/multiple-product",
    uploadCustomizedImage: mainDomain + "customized_image/upload",
    addCustomItemToCart: mainDomain + "cart/addCustomItem",
    updateUser: mainDomain + "user/update",
    getMultipleSize: mainDomain + "size/multiple",
    createCheckoutSession: mainDomain + "checkout/create-checkout-session",
    createCheckout: mainDomain + "checkout/checkout",
    createDirectOrder: mainDomain + "checkout/create-order",
    refundOrder: mainDomain + "checkout/refund",
    payNowOrder: mainDomain + "checkout/pay-now/",
    addAddress: mainDomain + "useraddress/create",
    validateUpsAddress: mainDomain + "ups/address/validate",
    upsTimeInTransit: mainDomain + "ups/time-in-transit",
    createUpsShipment: mainDomain + "ups/shipments/create",
    recoverUpsLabel: mainDomain + "ups/shipments/labels",
    validateAddressAndFetchRates: mainDomain + "ups/validate-address-and-rate",
  },
  deleteUrls: {
    removeCustomizedImage: mainDomain + "customized_image/delete",
    removeProduct: mainDomain + "products/delete",
    removeCartItem: mainDomain + "cart/remove",
    deleteAddress: mainDomain + "useraddress/delete",
    cancelUpsShipment: mainDomain + "ups/shipments/cancel",
  },
  putUrls: {
    updateCustomizedImage: mainDomain + "customized_image/update",
    updateUserAddress: mainDomain + "useraddress/update",
    updateProducts: mainDomain + "products/update",
    updateSingleProduct: mainDomain + "products/update-product",
  },
};
export default Constants;
